<template>
  <b-card
    :title="titulo"
    class="text-center"
  >
    <vue-apex-chart
      :type="tipo"
      :options="options"
      :series="series"
      height="300"
    />
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: { 'vue-apex-chart': VueApexCharts },
  props: ['tipo', 'titulo', 'options', 'series'],
}
</script>
